import React from "react";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();

  setTimeout(() => {
    navigate("/");
  }, 3000);

  return (
    <div className="container d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
      <div className="text-center">
        <div className="alert alert-danger" role="alert">
          <h1>Access Denied</h1>
          <p>You do not have permission to view this page. Redirecting to login...</p>
        </div>
      </div>
    </div>
  );
};

export default AccessDenied;
